import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {
  ContentDisplay,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import {
  IGetSuggestionDetailsResponse,
  ProductInformartionWithDisclaimer
} from '@/modules/wealth/services/investment-suggestions';
import * as captions from './constants';
import { IDynamicContent } from '@/modules/common/types';
import DynamicContentModal from '@/modules/common/components/DynamicContentModal/DynamicContentModal.vue';

interface Props {
  suggestionDetails: IGetSuggestionDetailsResponse;
  isInvestment: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestionDetails',
  props: {
    suggestionDetails: null,
    isInvestment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  suggestionDetails: IGetSuggestionDetailsResponse;
  isInvestment: boolean;
}



const isDynamicContentModalOpen = ref(false);
const dynamicContentModal = ref({
  title: '',
  description: [] as IDynamicContent[],
  showCostsButton: false
});

const toggleDynamicModal = (row: ProductInformartionWithDisclaimer) => {
  if (row) {
    dynamicContentModal.value.title = row.title;
    dynamicContentModal.value.description = row.disclaimer;
    dynamicContentModal.value.showCostsButton = !!row.action;
  }
  isDynamicContentModalOpen.value = !isDynamicContentModalOpen.value;
};

const summaryCaption = computed(() => {
  return props.isInvestment
    ? captions.investmentSummaryCaption
    : captions.redemptionSummaryCaption;
});

const portfolioCaption = computed(() => {
  if (props.suggestionDetails.portfolio.managementType === 'Manual') return '';
  return props.isInvestment
    ? captions.investmentPortfolioCaption
    : captions.redemptionPortfolioCaption;
});

const showExpireDate = computed(() => {
  const { expiredAt } = props.suggestionDetails.transaction;
  return expiredAt && expiredAt.formatted && expiredAt.formatted !== '';
});

const amountLabel = computed(() => {
  return props.isInvestment
    ? 'Valor total do investimento'
    : 'Valor total bruto';
});

const productAmountLabel = computed(() => {
  return props.isInvestment
    ? 'Valor do investimento'
    : 'Valor bruto do resgate';
});

return { __sfc: true,props, isDynamicContentModalOpen, dynamicContentModal, toggleDynamicModal, summaryCaption, portfolioCaption, showExpireDate, amountLabel, productAmountLabel, ContentDisplay, HeadingDisplay, ListDisplay, DynamicContentModal }
}

})